import { t } from '@if/core/i18n'
import { dateOnly, object, text, type InferSubmit } from '@if/core/yup'

// A cheque number is an int everywhere else it is stored, so it never exceeds 10 digits.
const CHEQUE_NUMBER_MAX_LENGTH = 20

// Digits only, kept as text so a leading zero printed on the cheque survives.
const CHEQUE_NUMBER_PATTERN = /^\d+$/

// What the cheque dialog collects before a selection is disbursed by cheque.
export const chequeDetailsSchema = object({
  chequeNumber: text()
    .required()
    .max(CHEQUE_NUMBER_MAX_LENGTH)
    .matches(CHEQUE_NUMBER_PATTERN, () => t('disburse.cheque.chequeNumberDigitsOnly')),
  chequeDate: dateOnly().required(),
})

export type ChequeDetailsSchemaType = InferSubmit<typeof chequeDetailsSchema>
